import { motion } from "framer-motion";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { gradientFor } from "../../../lib/groupColorPalette";

export default function ManagedGroupCard({ group, onClick, index = 0 }) {
  const { t } = useScriptMode();
  const banner = gradientFor(group.groupName);
  const templateCount = Array.isArray(group.qrTemplates)
    ? group.qrTemplates.length
    : 0;

  return (
    <motion.button
      type="button"
      onClick={() => onClick && onClick(group.id)}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, delay: index * 0.05 }}
      whileHover={{ y: -2 }}
      className="text-left w-full bg-white rounded-2xl shadow-sm hover:shadow-lg transition-shadow overflow-hidden flex flex-col focus:outline-none focus:ring-2 focus:ring-terakkiPrimary"
      aria-label={group.groupName}
    >
      <div className="h-3 w-full" style={{ background: banner }} />
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div className="flex items-start justify-between gap-2">
          <div className="font-SemiBold text-lg text-terakkiPrimary">
            {group.groupName}
          </div>
          <span
            className="text-xs font-Bold px-2 py-1 rounded-full text-white"
            style={{ background: "linear-gradient(120deg,#E1BC59,#B58B23)" }}
          >
            {t("groups_role_manager")}
          </span>
        </div>
        <div className="text-sm text-terakkiNeutral">
          {group.memberCount} {t("groups_member_count")} ·{" "}
          {group.totalManagers} {t("groups_manager_count")} ·{" "}
          {templateCount} {t("manage_card_template_count")}
        </div>
        {group.description ? (
          <div className="text-sm text-gray-600 line-clamp-2">
            {group.description}
          </div>
        ) : null}
      </div>
    </motion.button>
  );
}
